import apiService from './ApiService';

class AdminDashboardService {
  async getDashboard(regionalId) {
    return this.getDashboardGptClasicos(regionalId);
  }

  async getDashboardGptClasicos(regionalId) {
    if (!regionalId) {
      throw new Error('No hay regional seleccionado para cargar el dashboard.');
    }

    const response = await apiService.get(`/admindashboard/${regionalId}/gpt-clasicos`);

    if (response && typeof response.ok !== 'undefined' && !response.ok) {
      const msg = response.message || response.error || response.title || 'No pudimos cargar el dashboard.';
      throw new Error(msg);
    }

    return response;
  }
}

const adminDashboardService = new AdminDashboardService();

export default adminDashboardService;
